export default {
  //场景
  scene(options) {
    return {
      _name: 'scene_' + options.material_id,
      _title: options.name || '',
      _onstart: '',
      _havevrimage: 'true',
      _heading: '0.0',
      _thumburl: '',
      _lat: '31.11608261',
      _lng: '120.84626600',
      view: {
        _hlookatmin: options.hlookatmin,
        _hlookat: options.hlookat,
        _hlookatmax: options.hlookatmax,
        _vlookatmin: options.vlookatmin,
        _vlookat: options.vlookat,
        _vlookatmax: options.vlookatmax,
        _fovtype: 'MFOV',
        _fovmin: options.fovmin,
        _fov: options.fov,
        _fovmax: options.fovmax,
        _limitview: 'fullrage',
        _stereographic: options.stereographic,
      },
      preview: {
        _url: options.preview_url || '',
      },
      image: {
        cube: {
          _url: options.cube_url || '',
          _multires: options.multires || '',
        },
      },
    };
  },

  //热点
  hotspot(options) {
    let data = {
      _name: options.name,
      _type: options.type || 'image',
      _url: options.url || '',
      _keep: !!options.keep,
      _visible: !(options.visible === false),
      _style: options.style || '',
      _ath: options.ath || '0',
      _atv: options.atv || '0',
      _zoom: options.is_zoom || false, //  设置是否场景缩放时，热点跟随缩放
      _distorted: options.is_distorted || false, //  设置热点是否跟随场景进行3D扭曲
      _width: options.width || 70,
      _height: options.height || 70,
      _parent: options.parent || '',
      _html: options.html || '',
      _scale: options.scale || 1,
      _tx: options.tx || '',
      _ty: options.ty || '',
      _css: options.css || '',
      _borderwidth: options.borderwidth || '',
      _bordercolor: options.bordercolor || '',
      _borderalpha: options.borderalpha || '',
      _polyline: options.polyline || false,
      _enabled: options.handcursor == 2 ? false : true,
      _handcursor: options.handcursor == 2 ? false : true,
      _onclick: options.onclick || '',
      _ondown: options.ondown || '',
      _onover: options.onover || '',
      _onout: options.onout || '',
      point: Array.isArray(options.point)
        ? options.point.map((item) => {
            return { _ath: item.ath, _atv: item.atv };
          })
        : [],
    };
    if (options.type == 'text') {
      delete data._url;
    }
    return data;
  },

  //layer
  layer(options) {
    return {
      _name: options.name,
      _html: options.html || '',
      _type: options.type || 'text',
      _align: options.align || 'center',
      _visible: options.visible,
      _x: options.x || '0',
      _y: options.y || '0',
      _style: options.style || 'hotspot_label_style',
      _parent: options.parent || null,
      _onclick: options.onclick || '',
    };
  },
};
